import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signOut, useAuth } from "../../contexts/AuthContext";
import { Alert } from "../Alert";
import {
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Flex,
  Text,
  Spacer,
  Divider,
} from "@chakra-ui/react";
import { RoutesList } from "../../Routes";
import { verifyWhiteLabelPermission } from "../../utils/verifyWhiteLabelPermission";
import { MdOutlineLogout } from "react-icons/md";

export function SideBar() {
  const [undoChangesAlertState, setUndoChangesAlertState] = useState<boolean>(false);
  const [selectedPage, setSelectedPage] = useState<string>("");
  const user = JSON.parse(localStorage.getItem("barte-user-info"));
  const navigate = useNavigate();
  const { editionModeState, setEditionModeState } = useAuth();
  const { pathname } = useLocation();
  const ref = useRef();
  const Logout = (e) => {
    e.preventDefault();
    signOut();
    navigate("/login");
  };
  function handleUndoChanges(selectedPage: string) {
    if (editionModeState) {
      setUndoChangesAlertState(!undoChangesAlertState);
      setSelectedPage(selectedPage);
      return;
    }
    navigate(selectedPage);
  }

  function handleNavigate() {
    setUndoChangesAlertState(!undoChangesAlertState);
    setEditionModeState(!editionModeState);
    navigate(selectedPage);
  }

  return (
    <>
      <Alert
        isOpen={undoChangesAlertState}
        onClose={() => setUndoChangesAlertState(!undoChangesAlertState)}
        title="Tem certeza que deseja descartar as mudanças?"
        messageBody="As alterações que você fez agora serão perdidas."
        confirmButtonText="Descartar mudanças"
        closeButtonText="Cancelar"
        onConfirm={handleNavigate}
        leastDestructiveRef={ref}
      />
      <Box
        borderRight="1px"
        borderColor="#f0f0f0"
        position="relative"
        w={{ base: "230px", "2xl": "270px" }}
      >
        <Flex
          position="fixed"
          gridArea="S"
          borderRight="1px"
          borderColor="#f0f0f0"
          height="100vh"
          direction="column"
          bgColor="gray.24"
          w={{ base: "230px", "2xl": "270px" }}
          overflowY="auto"
          overflowX="hidden"
        >
          <Flex
            w="100%"
            p=".84rem 1rem"
            borderBottom="1px solid #E6E9F0"
          >
            <img
              src={`/logo-${process.env.REACT_APP_APPLICATION_NAME}.svg`}
              alt="Logo"
              width="75.64px"
              height="24px"
            />
          </Flex>
          <Accordion allowMultiple>
            {RoutesList
              ?.filter((item: any) => item?.isShowMenu)
              .map(({ icon, path, detail, title, items, isAccordion }: any, index) => (
                <React.Fragment  key={index}>
                {verifyWhiteLabelPermission(user?.email, path) && (
                  <AccordionItem
                    p="0 .4rem"
                    border="none"
                    my={3}
                    key={index}
                  >
                    <AccordionButton
                      id={index === 14 ? "click_menu_antecipar" : ""}
                      borderRadius="5"
                      bgColor={pathname === path ? "pink.50" : pathname}
                      onClick={() => (path !== "" && !isAccordion) ? handleUndoChanges(path) : ""}
                      onMouseDown={(e) => {
                        if (e.button === 1) {
                          e.preventDefault();
                          window.open(path, "_blank");
                        }
                      }}
                      _hover={{
                        backgroundColor: "pink.50",
                        fontcolor: "pink.200",
                        color: "pink.200",
                      }}
                    >
                      <Flex
                        key={title}
                        align={"center"}
                        gridGap="2"
                        w="100%"
                        _hover={{
                          fontcolor: "pink.200",
                          color: "pink.200",
                        }}
                      >
                        {path ? (
                            <Text
                              color={
                                (pathname === path ||
                                  pathname.startsWith(detail)) ?
                                "pink.200" : "inherit"
                              }
                            >
                              {title}
                            </Text>
                        ) : (
                          <Text
                            color={
                              (pathname === path ||
                                pathname.startsWith(detail)) ?
                              "pink.200" : "inherit"
                            }
                          >
                            {title}
                          </Text>
                        )}
                        {items && <AccordionIcon />}
                      </Flex>
                    </AccordionButton>
                    {items && (
                      <>
                        {items.map(({ path, title, }, index) => (
                          <React.Fragment key={index}>
                            {verifyWhiteLabelPermission(user?.email, path) && (
                              <AccordionPanel
                                borderRadius="5"
                                m=".2rem 0"
                                key={index}
                                py={2}
                                bgColor={
                                  pathname.includes(path) ? "pink.50" : pathname
                                }
                                color={pathname.includes(path) ? "pink.200" : pathname}
                                onClick={() => navigate(path)}
                                onMouseDown={(e) => {
                                  if (e.button === 1) {
                                    e.preventDefault();
                                    window.open(path, "_blank");
                                  }
                                }}
                                _hover={{
                                  backgroundColor: "pink.50",
                                  cursor: "pointer",
                                  fontcolor: "pink.200",
                                  color: "pink.200",
                                  "div > div": {
                                    backgroundColor: "pink.200"
                                  }
                                }}
                              >
                                  <Flex align="center" w="100%">
                                    <Box
                                      borderRadius="full"
                                      w="6px"
                                      h="6px"
                                      bg="gray.300"
                                      mr="4"
                                      backgroundColor={pathname.includes(path) ? "pink.200" : "gray.50"}
                                      color={path}
                                    />
                                    <Text
                                      color="inherit"                                    
                                    >
                                      {title}
                                    </Text>
                                  </Flex>
                              </AccordionPanel>
                            )}
                          </React.Fragment>
                        ))}
                      </>
                    )}
                  </AccordionItem>
                )}
                </React.Fragment>
              ))}
          </Accordion>
          <Spacer />
          <Divider />
          <Accordion
            mb="4"
            _hover={{
              cursor: "pointer"
            }}
          >
            <AccordionItem 
              border="none" 
              w="100%"
            >
              <AccordionButton 
                onClick={(e) => Logout(e)}
                _hover={{
                  backgroundColor: "pink.50",
                  fontcolor: "pink.200",
                  color: "pink.200",
                }}
              >
                <Flex
                  align="center"
                  gridGap="2"
                  color="inherit"
                >
                  <MdOutlineLogout
                    size={23}
                  />
                 
                  Sair
                </Flex>
              </AccordionButton>
            </AccordionItem>
          </Accordion>
        </Flex>
      </Box>
    </>
  );
};